import { createStore, combineReducers } from "redux";

import firstReducer from "./redux/reducers/firstReducer";

export default createStore(
  combineReducers({
    firstReducer
  })
);
